module.exports = __webpack_public_path__ + "static/media/LOGO.e8c88694.svg";